import { useAppData } from '../store/dataStore';

// Custom hook for FAQ data
export const useFaq = () => {
  const { appData } = useAppData();
  
  const faq = {
    beginner: [
      {
        q: "I have zero coding experience—can I really do this?",
        a: `Absolutely! We specialize in complete beginners. Our structured system takes you step-by-step from absolute zero to job-ready. ${appData.placementRate}% of our students started with no coding background.`
      },
      {
        q: "What if I fall behind or get stuck?",
        a: "Impossible to fall behind! We have NPLB (No Person Left Behind) policy with personalized support, extra sessions, and 1-on-1 mentoring until you succeed. That's our Learn for Sure guarantee."
      },
      {
        q: "How is this different from free YouTube tutorials?",
        a: "Free tutorials teach concepts. We provide a complete career transformation system: structured curriculum, real projects, mentorship, career support, and guaranteed results. You get hired, not just educated."
      },
      {
        q: `When does the next batch start?`,
        a: `Our next ${appData.course1.track} batch starts on ${appData.course1.startDate}. Join our ${appData.course1.WebinarDate} webinar to learn more and secure your spot.`
      }
    ],
    
    experienced: [
      {
        q: "I already know programming—will this be too basic?",
        a: "Not at all! We skip the basics and dive straight into advanced AI concepts. You'll build production-ready GenAI applications from week 1. Perfect for developers ready to level up."
      },
      {
        q: "Can I balance this with my full-time job?",
        a: `Absolutely! Sessions are ${appData.nextWebinarTime} IST with weekend reviews. All recordings available. Designed specifically for working professionals—many of our students complete while working full-time.`
      },
      {
        q: "How quickly can I expect career results?",
        a: `Most experienced developers see interviews within 4-6 weeks and offers by program end. With our ${appData.course2.track}, you'll be building production AI applications quickly.`
      },
      {
        q: `What's the investment for the ${appData.course2.track}?`,
        a: `The ${appData.course2.track} is priced at ₹${appData.course2.price} (original ₹${appData.course2.mrp}) - designed for experienced developers who want to accelerate their AI career.`
      }
    ]
  };

  return { faq };
};

// Export the hook
export default useFaq;